import { gql } from 'apollo-angular'

// Editing a schedule replaces it: the stored row is deleted and the edited
// one inserted under the same id. Both steps travel in one request, which
// Hasura runs in this order as one transaction, so if either fails nothing is
// written and the stored schedule is still there.
//
// The id is kept on purpose. A second save of the same schedule (a second
// click, another tab) then replaces the first one's row or collides with it;
// with a new id per save it would add a second copy, and every reminder and
// missed-test e-mail of the schedule would go out twice.
export default gql`
  mutation replace_schedule($id: Int!, $schedule: schedule_insert_input!) {
    delete_schedule(where: { id: { _eq: $id } }) {
      affected_rows
    }
    insert_schedule(objects: [$schedule]) {
      returning {
        id
      }
    }
  }
`
